import { Schema, model, models, Document, Model, Types } from "mongoose";
import { NetworkSymbols } from "based-auth/networks";
import { UserRole } from "based-shared/types";

export interface IUserMetaInfo {
  website: string;
  twitter: string;
  telegram: string;
  discord: string;
}

export interface IUser {
  network: NetworkSymbols;
  address: string;
  social: string;
  provider: string;
}

export interface IUserProfile extends Document {
  _id: Types.ObjectId;
  id: string;
  name: string;
  bio: string;
  image: string;
  banner: string;
  metaInfo: IUserMetaInfo;
  role: UserRole;
  lastNetwork: string;
  lastSignedIn: Date;
  lastAddress: string;
  followers: {
    network: string;
    address: string;
  }[];
  users: IUser[];
}

const userProfileSchema = new Schema(
  {
    name: {
      type: String,
      default: "",
      required: true,
      index: true,
    },
    bio: {
      type: String,
      default: "",
    },
    image: {
      type: String,
      default: "",
    },
    banner: {
      type: String,
      default: "",
    },
    metaInfo: {
      website: {
        type: String,
        default: "",
      },
      twitter: {
        type: String,
        default: "",
      },
      telegram: {
        type: String,
        default: "",
      },
      discord: {
        type: String,
        default: "",
      },
    },
    lastNetwork: {
      type: String,
      default: "",
    },
    lastSignedIn: {
      type: Date,
      default: Date.now,
    },
    lastAddress: {
      type: String,
      default: "",
    },
    followers: [
      {
        type: Schema.Types.ObjectId,
        ref: "UserProfile",
      },
    ],
    users: [
      {
        network: {
          type: String,
          enum: Object.values(NetworkSymbols),
          required: true,
        },
        address: {
          type: String,
          required: true,
        },
        social: {
          type: String,
          default: "",
        },
        provider: {
          type: String,
          default: "",
        },
      },
    ],
  },
  {
    timestamps: true,
    toObject: {
      getters: true,
      versionKey: false,
      transform: (doc, ret: any) => {
        ret.id = ret._id.toString();
        ret.users = ret.users.map(({ _id, ...remains }: any) => ({
          ...remains,
          id: _id.toString(),
        }));
        delete ret._id;
        delete ret.__v;
        return ret;
      },
    },
  }
);

userProfileSchema.index(
  { "users.network": 1, "users.address": 1 },
  { unique: true }
);

export const UserProfileModel: Model<IUserProfile> =
  models?.UserProfile || model<IUserProfile>("UserProfile", userProfileSchema);
